"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapFeatureToggles = mapFeatureToggles;
function mapFeatureToggles(enabledFeatures, featureKeys) {
  return Object.entries(featureKeys).reduce((accumulator, [featureName, featureId]) => {
    accumulator[`${featureName}:${featureId}`] = enabledFeatures.includes(featureId) ? 'active' : 'inactive';
    return accumulator;
  }, {});
}
